import _ from 'lodash'
import { MutationTree } from 'vuex';
import { Schedule, SchedulesState } from '@/store/schedules/types';

const mutations: MutationTree<SchedulesState> = {
  gotSchedule(state, schedule: Schedule) {
    state.schedules = _.uniqBy([schedule, ...state.schedules], 'id')
  },
}

export default mutations
